module.exports = __webpack_public_path__ + "static/media/S35_W.efb85e5e.png";